import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CHOOSER_CARD_COLORS","ChooseIndustryClient"] */ "/workspace/src/app/(public)/choose-your-industry/client.tsx");
